__turbopack_context__.v({
  "Content": "ce4hLW_Content",
  "Header": "ce4hLW_Header",
  "Open": "ce4hLW_Open",
  "Svg": "ce4hLW_Svg",
  "Title": "ce4hLW_Title",
  "simple-collapsible-slide-down": "ce4hLW_simple-collapsible-slide-down",
  "simple-collapsible-slide-up": "ce4hLW_simple-collapsible-slide-up",
});
